import { cx } from '@/lib/utils/cx';

import type { SVGProps } from 'react';

/**
 * The Gmail brand mark lives in exactly one place: `public/svg/gmail.svg`. The
 * `<img>`-based provider strips (`provider-mark`, `auth-feature-showcase`) point
 * at that same file, so the logo is swapped by replacing the SVG alone.
 *
 * Rendered as an `<img>` rather than inline SVG so its two global gradient ids
 * (`a`, `b`) stay sandboxed per element — inlining N copies would collide them.
 * `object-contain` preserves the non-square (800×636) aspect ratio inside the
 * square sizing classes (`size-6`, …) callers pass, matching inline-SVG `meet`.
 *
 * `alt=""` (decorative): every call site renders the mark beside the provider's
 * visible name, so a non-empty alt would double-announce. Icon-only surfaces use
 * `provider-mark`, which sets its own alt. The `SVGProps` signature (className is
 * the only prop any call site passes) keeps it assignable to the provider-icon
 * registries alongside the real inline-SVG marks.
 */
const GMAIL_ICON_SRC = '/svg/gmail.svg';

const Gmail = ({ className }: SVGProps<SVGSVGElement>) => (
  <img alt="" className={cx('object-contain', className)} src={GMAIL_ICON_SRC} />
);

export { Gmail };
